import React, { useState } from "react";
import { Box } from "@mui/material";

import { PageLayout } from "../../layouts/PageLayout";
import { CRMService } from "../../services";
import { PageHeader } from "../../components/v3";
import { LeadActivityCard, LeadDetails } from "../../components/crm";
import { get_date } from "../../components/generalComponets";

export const SingleLead = () => {
  const [leadDetails, setLeadDetails] = useState({});
  const [leadData, setLeadData] = useState({ assignees: [], status: null, note: "" });
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);

  const handleStatusChange = (selected) => {
    if (!selected) setSelectedStatus(null);
    setSelectedStatus(selected);
    setLeadData((prev) => ({ ...prev, status: { id: selected?.id, name: selected?.name } }));
  };

  const handlePriorityChange = (selected) => {
    if (!selected) setSelectedPriority(null);
    setSelectedPriority(selected);
    setLeadData((prev) => ({ ...prev, priority: { id: selected?.id, name: selected?.name } }));
  };

  const sortedActivities = leadDetails.activities?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  return (
    <PageLayout>
      {/* header section */}
      <Box component="main" sx={{ flexGrow: 1, position: "relative", minWidth: 0, width: "100%" }}>
        <PageHeader
          // title
          title="Lead Details"
          subtitle={get_date(leadDetails.createdAt)}
          // select input
          inputFields={[
            {
              label: "Lead Status",
              value: selectedStatus,
              fetchData: CRMService.getLeadStatuses,
              onChange: handleStatusChange,
            },
            {
              label: "Priority",
              value: selectedPriority,
              fetchData: () => CRMService.getLeadPriorities({ includeGlobal: true }),
              onChange: handlePriorityChange,
            },
          ]}
        />

        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <Box sx={{ display: "flex" }}>
            {/* lead details */}
            <Box flex={1}>
              <LeadDetails
                setSelectedStatus={setSelectedStatus}
                setSelectedPriority={setSelectedPriority}
                leadDetails={leadDetails}
                setLeadDetails={setLeadDetails}
                leadData={leadData}
                setLeadData={setLeadData}
              />
            </Box>
            {/* lead activity */}
            <Box flex={1}>
              <LeadActivityCard title="Activity" activities={sortedActivities} />
            </Box>
          </Box>
        </Box>
      </Box>
    </PageLayout>
  );
};
